<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-8 profile">
        <!-- Without CMS -->
        <div v-if="isCmsUsed === false">
          <h2>My Bonuses</h2>
        </div>
        <!-- With CMS -->
        <div v-if="isCmsUsed === true" v-html="leftContent"></div>
        <!--Accordion wrapper-->
        <div
          class="accordion md-accordion"
          id="accordionEx1"
          role="tablist"
          aria-multiselectable="true"
        >
          <!-- Accordion card -->
          <div class="card">
            <!-- Card header -->
            <div class="card-header" role="tab" id="headingTwo1">
              <a
                id="accord1"
                class="collapsed"
                data-toggle="collapse"
                data-parent="#accordionEx1"
                href="#collapseTwo1"
                aria-expanded="true"
                aria-controls="collapseTwo1"
              >
                <h5 class="mb-0">
                  £30 per vehicle bonus<i
                    class="fas fa-plus-circle rotate-icon"
                  ></i>
                </h5>
              </a>
            </div>

            <!-- Card body -->
            <div
              id="collapseTwo1"
              class="collapse"
              role="tabpanel"
              aria-labelledby="headingTwo1"
              data-parent="#accordionEx1"
            >
              <div class="card-body">
                <p>
                  Cardholders who introduce new business customers to the
                  Quartix vehicle and fleet tracking system through ourselves
                  will receive a £30 per vehicle bonus on their card.
                  <span style="font-size: 0.7rem;"
                    >(Terms & Conditions apply)</span
                  >
                  <br />
                  To send your contacts a text message link to a web page with
                  more details just complete their info below and click Send
                  text now
                </p>
                <form action="form" @submit.prevent="sendInvitation(1)">
                  <div class="row">
                    <div class="col-md-6" style="padding-right: 9px;">
                      <input
                        type="text"
                        id="firstname"
                        name="firstname"
                        placeholder="First Name"
                        v-model="firstName"
                      />
                    </div>
                    <div class="col-md-6" style="padding-left: 9px;">
                      <input
                        type="text"
                        id="lastname"
                        name="lastname"
                        placeholder="Last Name"
                        v-model="lastName"
                      />
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-6" style="padding-right: 9px;">
                      <input
                        type="text"
                        id="mobnum"
                        name="mobnum"
                        placeholder="Mobile Number"
                        v-model="mobile"
                      />
                    </div>
                    <!-- <div class="col-md-6" style="padding-left: 9px;">
                      <input
                        type="email"
                        id="emailadd"
                        name="emailadd"
                        placeholder="Email Address ( Optional )"
                        v-model="email"
                      />
                    </div> -->
                  </div>
                  <button
                    v-if="isSendingInvitationEmailButtonLoading === true"
                    type="submit"
                    disabled
                  >
                    <span
                      class="spinner-border spinner-border-sm"
                      role="status"
                      aria-hidden="true"
                    ></span>
                    Sending invitation text...
                  </button>
                  <button
                    v-if="isSendingInvitationEmailButtonLoading === false"
                    type="submit"
                  >
                    Send text now
                  </button>
                </form>
              </div>
            </div>
          </div>
          <!-- Accordion card -->

          <!-- Accordion card -->
          <div class="card">
            <!-- Card header -->
            <div class="card-header" role="tab" id="headingTwo2">
              <a
                class="collapsed"
                data-toggle="collapse"
                data-parent="#accordionEx1"
                href="#collapseTwo21"
                aria-expanded="false"
                aria-controls="collapseTwo21"
              >
                <h5 class="mb-0">
                  BONUSme new client £250 bonus<i
                    class="fas fa-plus-circle rotate-icon"
                  ></i>
                </h5>
              </a>
            </div>

            <!-- Card body -->
            <div
              id="collapseTwo21"
              class="collapse"
              role="tabpanel"
              aria-labelledby="headingTwo21"
              data-parent="#accordionEx1"
            >
              <div class="card-body">
                <p>
                  We're looking forward to welcoming more dealers, warranty,
                  parts, finance, insurance, hire... companies into the network.
                  So if you think that a company that you do business with might
                  be interested in growing their market share by joining the
                  Bonusme network, just send them a text link and if they become
                  a new subscribing client we’ll add £250 to your card.
                </p>
                <form action="form" @submit.prevent="sendInvitation(2)">
                  <div class="row">
                    <div class="col-md-6" style="padding-right: 9px;">
                      <input
                        type="text"
                        id="firstname"
                        name="firstname"
                        placeholder="First Name"
                        v-model="firstName"
                      />
                    </div>
                    <div class="col-md-6" style="padding-left: 9px;">
                      <input
                        type="text"
                        id="lastname"
                        name="lastname"
                        placeholder="Last Name"
                        v-model="lastName"
                      />
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-6" style="padding-right: 9px;">
                      <input
                        type="text"
                        id="mobnum"
                        name="mobnum"
                        placeholder="Mobile Number"
                        v-model="mobile"
                      />
                    </div>
                    <!-- <div class="col-md-6" style="padding-left: 9px;">
                      <input
                        type="email"
                        id="emailadd"
                        name="emailadd"
                        placeholder="Email Address ( Optional )"
                        v-model="email"
                      />
                    </div> -->
                  </div>
                  <button
                    v-if="isSendingInvitationEmailButtonLoading === true"
                    type="submit"
                    disabled
                  >
                    <span
                      class="spinner-border spinner-border-sm"
                      role="status"
                      aria-hidden="true"
                    ></span>
                    Sending invitation text...
                  </button>
                  <button
                    v-if="isSendingInvitationEmailButtonLoading === false"
                    type="submit"
                  >
                    Send text now
                  </button>
                </form>
              </div>
            </div>
          </div>
          <!-- Accordion card -->

          <!-- Accordion card -->
          <div class="card">
            <!-- Card header -->
            <div class="card-header" role="tab" id="headingThree31">
              <a
                class="collapsed"
                data-toggle="collapse"
                data-parent="#accordionEx1"
                href="#collapseThree31"
                aria-expanded="false"
                aria-controls="collapseThree31"
              >
                <h5 class="mb-0">
                  Offer your own bonus<i
                    class="fas fa-plus-circle rotate-icon"
                  ></i>
                </h5>
              </a>
            </div>

            <!-- Card body -->
            <div
              id="collapseThree31"
              class="collapse"
              role="tabpanel"
              aria-labelledby="headingThree31"
              data-parent="#accordionEx1"
            >
              <div class="card-body">
                <p>
                  The BONUSme platform is flexible enough to enable any size of
                  business to reward the way they want to. Should you wish to
                  control the range of incentives offered to your audience, this
                  ‘My Bonuses’ section can be changed for your business, so that
                  you can switch on or off the ‘invite a friend’ functionality
                  and have your own incentive summary/s to remind people how
                  they can boost their income by helping your business achieve
                  its objectives.We can also create fully bespoke branded
                  programmes on our solution platform. For an initial discussion
                  call our client services team on 01292 623355
                </p>
              </div>
            </div>
          </div>
          <!-- Accordion card -->
        </div>
        <!-- Accordion wrapper -->
        <div class="spacer-60"></div>
      </div>

      <div class="col-md-4 promos">
        <Promotions />
      </div>
      <div class="col-md-4 promos promos2">
        <Promotions />
      </div>
    </div>
    <Cards />
    <footer>
      <div class="row">
        <div class="col-md-12">
          <p>
            This website hosted at URL Bonusme.uk is provided by Performance
            Bonus Ltd a company registered in England and Wales (registration
            number 4326332) Registered Office: 2 St Mary Street, Chepstow,
            Monmouthshire, NP16 5EU. The Card and electronic money (‘e-money’)
            loaded on it are issued by Payment Card Solutions (UK) Limited
            trading as B4B Payments, a company registered in England and Wales
            (registration number 05941947) and registered office at 21-24
            Millbank, London, England, SW1P 4QP. Payment Card Solutions (UK)
            Limited is authorised and regulated in the UK by the Financial
            Conduct Authority (Firm Reference Number: 930619) for the issuing of
            e-money. Mastercard is a registered trademark, and the circles
            design is a trademark of Mastercard International Incorporated.
          </p>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
import Cards from "./Cards";
import actions from "@/store/invites/actions";
import Promotions from "./Promotions.vue";
export default {
  components: {
    Cards,
    Promotions
  },
  created() {
    this.leftContent =
      this.isCmsUsed === true &&
      this.cmsPage != undefined &&
      this.cmsPage.leftContent != null
        ? this.cmsPage.leftContent
        : "";
  },
  data: () => ({
    firstName: null,
    lastName: null,
    mobile: null
    // email: null
  }),
  computed: {
    isCmsUsed: {
      get() {
        return this.$store.state.cms.isCmsUsed;
      }
    },
    cmsPage: {
      get() {
        return this.$store.state.cms.cmsPage;
      }
    },
    isSendingInvitationEmailButtonLoading: {
      get() {
        return this.$store.state.settings.isSendingInvitationEmailButtonLoading;
      },
      set(value) {
        this.$store.commit(
          "updateIsSendingInvitationEmailButtonLoadingMutation",
          value
        );
      }
    }
  },
  methods: {
    sendInvitation: async function(campaignId) {
      this.isSendingInvitationEmailButtonLoading = true;
      const formedPayload = {
        firstName: this.firstName,
        lastName: this.lastName,
        mobile: this.mobile,
        campaignId
        // email: this.email
      };

      await this.$store.dispatch(
        actions.POST_INVITE_FRIEND_DATA,
        formedPayload
      );
    }
  }
};
</script>
